<template>

  <main>
    <app-draw-feature 
      @drawend="onDrawEnd"
      ref="draw" :map="map" :mode="drawMode" :active="isActive" :drawing="isDrawActive"></app-draw-feature>

    <app-raster-legend
      ref="legend"
      :value="isActive && !isDynamicStyle"
      style="position: absolute; bottom: 15px; margin-left: 15px; z-index: 1;"
      layout="vertical" class="app-raster-legend"></app-raster-legend>

    <v-navigation-drawer ref="nav" app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">
      <v-container fluid class="pa-0">
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('busquedas') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$store.dispatch('disableControl')" :disabled="isLoading">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider></v-divider>

      <v-container fluid class="pa-0">
        <v-card flat :color="`grey ${$store.getters.isDarkTheme ? 'darken-4' : 'lighten-4'}`" height="64">
          <div class="container-buttons">
            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" @click="repeatSearch" :disabled="disabledButtons" fab small color="green darken-2">
                <v-icon>youtube_searched_for</v-icon>
              </v-btn>
              <span>{{ $t('_busquedas.nueva') }}</span>
            </v-tooltip>

            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" @click="showBufferDialog = true" :disabled="disabledButtons" fab small color="green darken-2">
                <v-icon>open_with</v-icon>
              </v-btn>
              <span>{{ $t('_busquedas.buffer') }}</span>
            </v-tooltip>

            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" :disabled="showBufferDialog || isLoading" @click="isDynamicStyle = !isDynamicStyle" fab small :color="isDynamicStyle ? 'red darken-2' : 'blue darken-1'">
                <v-icon>palette</v-icon>
              </v-btn>
              <span>{{ $t('cambiar-estilo') }}</span>
            </v-tooltip>

            <v-tooltip bottom style="align-self: center;">
              <v-btn slot="activator" @click="printDialogOpened = true" :disabled="disabledButtons" fab small color="green darken-2">
                <v-icon>print</v-icon>
              </v-btn>
              <span>{{ $t('descargar-ficha') }}</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-container>

      <app-select-draw-mode
        ref="drawModeSelector" 
        @change-draw-mode="onDrawModeChange"
        punto poligono rectangulo defaultMode="Polygon"></app-select-draw-mode>

        <v-scale-transition>
          <v-alert v-show="isDrawActive" type="info" :color="$store.getters.isDarkTheme ? 'green darken-2' : 'green lighten-2'" class="mt-0">
            {{ $t(drawMode == geometryModes.POINT ? 'dibuja.punto' : 'dibuja.poligono') }}
          </v-alert>
        </v-scale-transition>

      <v-container fluid class="pa-0">
        <v-toolbar 
          style="cursor: pointer;"
          @click="collapsed = !collapsed" :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`">
          <v-btn icon>
            <v-icon>settings</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 16px;">{{$t('opciones')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="collapsed = !collapsed">
            <v-icon>{{collapsed ? 'add' : 'remove'}}</v-icon>
          </v-btn>
        </v-toolbar>
      </v-container>

      <v-divider :dark="$store.getters.isDarkTheme" v-if="collapsed && isDynamicStyle"></v-divider>

      <v-container fluid class="pa-0">
        <v-slide-y-transition>
          <v-card v-show="!collapsed" :color="$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'" class="px-3 pb-3">
            <v-layout row wrap>
              <v-flex xs6 class="px-2">
                <app-select-indicador
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-indicador>
              </v-flex>
              <v-flex xs6 class="px-2">
                <app-select-period
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-period>
              </v-flex>

              <v-flex xs6 class="px-2 pt-2">
                <app-select-ortofotos
                  :map="map"
                  :ortoLayer="LayerOrto"
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-ortofotos>
              </v-flex>

              <v-flex xs6 class="px-2 pt-2">
                <app-select-raster
                  ref="rasterselect"
                  :value="isActive"
                  :disabled="disabledButtonsByDialogs || (isDrawActive && !!result)"></app-select-raster>
              </v-flex>

              <v-flex xs12 class="px-2">
                <app-select-saved-polygon
                  ref="selectSavedPolygon"
                  v-show="drawMode == geometryModes.POLYGON || drawMode == geometryModes.CIRCLE"
                  :map="map"
                  :disabled="isLoading || showBufferDialog"
                  @selected="onSelectedSavedPolygon"
                ></app-select-saved-polygon>
              </v-flex>
            </v-layout>

          </v-card>
        </v-slide-y-transition>
      </v-container>

        <!-- Diálogo para elegir la distancia del buffer -->
        <app-buffer-feature
          @selected="onBufferSelected"
          @cancel="showBufferDialog = false"
          :feature="lastFeature"
          :map="map"
          :value="showBufferDialog"></app-buffer-feature>

        <!-- Diálogo para elegir el estilo de la capa raster -->
        <app-raster-filter
          ref="rasterfilter"
          :rasterLayer="LayerRaster" 
          v-if="!showBufferDialog"
          :value="isDynamicStyle && isActive"></app-raster-filter>

      <v-divider :dark="$store.getters.isDarkTheme"></v-divider>

      <v-tabs
        :color="`green ${$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'}`"
        :height="$vuetify.breakpoint.mdAndUp ? 64 : 56"
        v-if="result && !showBufferDialog" icons-and-text centered :dark="$store.getters.isDarkTheme">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab href="#tab-chart"> {{$t('grafica')}} <v-icon>insert_chart</v-icon> </v-tab>
        <v-tab href="#tab-data"> {{$t('datos')}} <v-icon>view_column</v-icon> </v-tab>

        <v-tab-item id="tab-chart">
          <!-- Contenedor de la gráfica + funcionalidades de gráfica -->
          <app-search-chart
            ref="chart"
            v-show="!disabledButtonsByDialogs"
            :rasters="$refs.rasterselect && $refs.rasterselect.rasters"
            :result="result"
          ></app-search-chart>
        </v-tab-item>

        <v-tab-item id="tab-data">
          <v-scale-transition>
            <v-container v-show="!!result" fluid class="pa-0">
              <v-layout row wrap style="justify-content: space-around;">
                <v-flex xs6 v-if="drawMode !== 'Point'">
                  <v-card height="120" flat ripple>
                    <v-card-text class="text-xs-center">
                      <v-card-actions>
                        <v-btn icon style="margin: 0px auto;">
                          <vector-polygon-icon style="font-size: 24px;"></vector-polygon-icon>
                        </v-btn>
                      </v-card-actions>
                      <h2 v-html="formattedArea"></h2>
                      <span>{{$t('area-poligono')}}</span>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs6>
                  <v-card height="120" flat ripple>
                    <v-card-text class="text-xs-center">
                      <v-card-actions>
                        <v-btn icon :ripple="false" style="margin: 0px auto;">
                          <v-icon>people</v-icon>
                        </v-btn>
                      </v-card-actions>
                      <h2>{{population || 0}} hab.</h2>
                      <span>{{$t('poblacion-afectada')}}</span>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-scale-transition>
        </v-tab-item>
      </v-tabs>

    </v-navigation-drawer>

    <print-report
      ref="print"
      :map="map" 
      :chart="$refs.chart && $refs.chart.$data.chart"
      :printDialogOpened="printDialogOpened"
      :period="period" 
      :lastFeature="lastFeature"
      :legend="isDynamicStyle ? linearGradient : ($refs.legend && $refs.legend.legendURL && $refs.legend.legendURL.replace('0x000000', '0xFFFFFF'))"
    ></print-report>

  </main>
</template>


<script>
import * as API from '@/api'

import SourceTileWMS from 'ol/source/tilewms'
import VectorLayer from 'ol/layer/vector'
import VectorSource from 'ol/source/vector'
import OLSphere from 'ol/sphere'

import GeomPolygon from 'ol/geom/polygon'
import GeomPoint from 'ol/geom/point'
import Feature from 'ol/feature'

import AppRasterFilter from '../utils/shared-components/raster-range-filter'
import AppSelectIndicador from '../utils/shared-components/select-indicador'
import AppSelectPeriod from '../utils/shared-components/select-period'
import AppSelectRaster from '../utils/shared-components/select-raster'
import AppSelectOrtofotos from '../utils/shared-components/select-ortofoto'
import AppSelectSavedPolygon from '../utils/shared-components/select-saved-polygon'
import AppBufferFeature from '../utils/shared-components/buffer-feature'
import AppDrawFeature from '../utils/shared-components/draw-feature'
import AppRasterLegend from '../utils/shared-components/raster-legend'

import AppSelectDrawMode from '../utils/shared-components/select-draw-mode'

import { LayerOrto, LayerRaster, LayerAmbito } from '../utils/layers'
import { showStyle, styleDifference } from '../utils/style'
import GetFeatureDifference from '../utils/feature-difference'

import AppSearchChart from './charts/chart-search'

import PrintReport from './PrintReport'

const LayerShow = new VectorLayer({ source: new VectorSource, style: showStyle })

/**
 * Componente para realizar búsquedas/consultas sobre
 * los rásters
 */
export default {

  props: ['map'],

  components: {
    PrintReport,
    AppRasterFilter,
    AppSelectIndicador,
    AppSelectPeriod,
    AppSelectRaster,
    AppSelectOrtofotos,
    AppSelectSavedPolygon,
    AppBufferFeature,
    AppSearchChart,
    AppRasterLegend,
    AppDrawFeature,
    AppSelectDrawMode
  },

  data() {
    return {
      /* Identificador del Componente */
      id: 'Search-Component',

      /* Podemos dibujar un punto o polígono */
      geometryModes: {
        POINT: 'Point',
        POLYGON: 'Polygon',
        CIRCLE: 'Circle'
      },

      drawMode: null,

      clickHandlerId: null,

      lastFeature: null,

      result: null,

      showBufferDialog: false,

      isDynamicStyle: false,

      LayerRaster,
      LayerOrto,

      isDrawActive: false,

      affectedPopulation: null,

      collapsed: false
    }
  },

  methods: {

    onDrawModeChange(mode) {
      this.drawMode = mode
      if(this.isActive) {
        this.isDrawActive = true
      }
    },

    checkControl(newControl, lastControl) {
      return newControl.startsWith(this.id) || lastControl.startsWith(this.id)
    },
    
    async getResultsForPolygon(feature) {
      this.result = null
      const rasters = this.$refs.rasterselect.rasters

      const promises = [
        API.getPolygonStats(rasters, feature),
        API.getRastersAverage(rasters),
        API.getPopulation(feature)
      ]

      const [result, ambitoStats, population] = await Promise.all(promises)

      this.affectedPopulation = population
      this.result = result.map((value, idx) => [value, ambitoStats[idx]])
    },

    async getResultsForPoint(feature) {
      this.affectedPopulation = null
      this.result = null
      const rasters = this.$refs.rasterselect.rasters
      const coordinates = feature.getGeometry().getCoordinates()

      const promises = [
        API.getFeatureInfo(rasters, coordinates, this.map),
        API.getRastersAverage(rasters),
        API.getPopulation(new Feature({geometry: new GeomPoint(coordinates) }))
      ]

      const [result, ambitoStats, population] = await Promise.all(promises)

      this.affectedPopulation = population
      this.result = result.map((value, idx) => [value, ambitoStats[idx]])
    },

    async calculate() {
      if(this.lastFeature) {
        this.isLoading = true
        const type = this.lastFeature.getGeometry().getType()
        if(type == 'Polygon' || type == 'Circle') {
          await this.getResultsForPolygon(this.lastFeature)
        } else if(type == 'Point') {
          await this.getResultsForPoint(this.lastFeature)
        }
        this.isLoading = false
      }
    },

    repeatSearch() {     
      this.isDrawActive = true
      this.selectedPolygon = null
      this.result = null
    },

    onBufferSelected(bufferFeature) {
      this.showBufferDialog = false
      this.selectedPolygon = null
      this.lastFeature = bufferFeature
    },

    fitMapToFeatureExtent(duration = 500) {
      if(this.lastFeature) {
        const type = this.lastFeature.getGeometry().getType()
        const extent = this.lastFeature.getGeometry().getExtent()
        const constrainResolution = false
        const padding = [10, 10, 10, 10]
        const center = this.lastFeature.getGeometry().getCoordinates()
        const zoom = 15

        if(type == 'Point') {
          this.map.getView().animate({ center, duration: duration / 2 }, { zoom, duration: duration / 2 })
        } else {
          this.map.getView().fit(extent, { duration, constrainResolution, padding })
        }

      }
    },

    paintRaster() {
      if(!this.raster) {
        return
      }

      const { name: layers, url } = this.raster
      const source = new SourceTileWMS({ url, params: { layers }, crossOrigin: 'anonymous' })
      
      LayerRaster.setSource(source)
    },

    onSelectedSavedPolygon(selectedPolygon) {
      this.isDrawActive = false
      this.lastFeature = selectedPolygon
    },

    onDrawEnd(feature) {
      this.isDrawActive = false
      this.lastFeature = feature
    }
  },

  computed: {

    population() {
      if(!this.affectedPopulation) {
        return
      }

      if(typeof this.affectedPopulation == 'object') {
        const { POBLACION } = this.affectedPopulation
        return POBLACION
      }

      return this.affectedPopulation
    },

    formattedArea() {
      const area = this.affectedArea
      let output = ''

      if(!area) {
        return
      }

      if (area > 10000) {
        output = `${(Math.round(area / 1000000 * 100) / 100)} km<sup>2</sup>`
      } else {
        output = `${(Math.round(area * 100) / 100)} m<sup>2</sup>`
      }
      
      return output
    },

    affectedArea() {
      if(!this.lastFeature) {
        return
      }
      
      const geometry = this.lastFeature.getGeometry()
      const type = geometry.getType()

      return type != 'Point' && OLSphere.getArea(geometry)
    },

    linearGradient() {
      const rasterfilter = this.$refs.rasterfilter

      if(!rasterfilter) {
        return
      }

      const { minColor, maxColor, minValue, maxValue } = rasterfilter

      return { minColor, maxColor, minValue, maxValue }
    },

    selectedPolygon: {
      get() { return this.$refs.selectSavedPolygon && this.$refs.selectSavedPolygon.$data.selectedPolygon },
      set(value) { this.$refs.selectSavedPolygon.$data.selectedPolygon = value }
    },

    raster: {
      get() { return this.$store.getters.raster },
      set(value) { this.$store.dispatch('setRaster', value) }
    },

    period() {
      return this.$store.getters.period
    },

    printDialogOpened: {
      get() { return this.$refs.print && this.$refs.print.printDialogOpened },
      set(value) { this.$refs.print.printDialogOpened = value }
    },

    disabledButtons() {
      return !!!this.result || this.isLoading || this.showBufferDialog || this.isDrawActive
    },

    disabledButtonsByDialogs() {
      return this.isLoading || this.showBufferDialog
    },

    indicadores() {
      return Object.keys(this.$store.getters.indicadores)
        .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    },

    isLoading: {
      get() {
        return this.$store.getters.isLoading
      },
      set(value) {
        this.$store.dispatch('setLoading', value)
      }
    },

    activeControlId() {
      return this.$store.getters.activeControlId
    },
    
    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id)
    },

    indicador() {
      return this.$store.getters.indicador
    },

  },

  watch: {

    map() {
      const fn = () => {
        if(!this.lastFeature || this.isDrawActive || this.mode == 'Point') return

        LayerShow.getSource().clear()

        const extent = this.map.getView().calculateExtent()
        const p1 = new Feature({ geometry: GeomPolygon.fromExtent(extent) })
        const p2 = this.lastFeature

        const feature = GetFeatureDifference(p1, p2, this.map.getView().getProjection())

        if(!feature) {
          return LayerShow.getSource().addFeature(this.lastFeature)
        }

        feature.setStyle(styleDifference)

        LayerShow.getSource().addFeature(feature)
        LayerShow.getSource().addFeature(this.lastFeature)
      }

      this.map.getTargetElement().addEventListener('resize', fn)
      this.map.on('precompose', fn)
      this.map.on('postcompose', fn)
    },

    lastFeature() {
      if(!this.lastFeature) {
        return
      }

      this.lastFeature.setStyle(showStyle)
      
      LayerShow.getSource().clear()
      LayerShow.getSource().addFeature(this.lastFeature)

      this.fitMapToFeatureExtent()

      this.calculate()
    },

    activeControlId(newControl, lastControl) {
      if(!this.checkControl(newControl || '', lastControl || '')) {
        return
      }

      this.map.getLayers().forEach(layer => layer.setVisible(!this.isActive))

      ;[LayerOrto, LayerRaster, LayerAmbito, LayerShow]
        .forEach(layer => layer.setMap(this.isActive ? this.map : null))


      this.isActive && this.paintRaster()
      this.isActive && this.$parent.fitIntoProjectExtent()

      LayerShow.getSource().clear()
      
      this.collapsed = false
      this.affectedPopulation = null
      this.isDrawActive = !!this.isActive
      this.isDynamicStyle = false
      this.result = null
      this.showBufferDialog = false
      this.selectedPolygon = null
      this.lastFeature = null
    },

    indicador() {
      if(this.isActive) {
        this.isDynamicStyle = false    
        this.calculate()
      }
    },

    raster() {
      if(this.isActive) {
        this.paintRaster()
      }
    },

    isDynamicStyle() {
      if(!this.isDynamicStyle) {
        this.paintRaster()
      }
    },

    period() {
      if(this.isActive) {
        this.calculate()
      }
    },

    showBufferDialog(show) {
      if(show) {
        LayerShow.getSource().clear()
      }
    },

    isDrawActive(active) {
      if(active) {
        LayerShow.getSource().clear()
      }
    },
  },
}
</script>


<style>
.container-buttons {
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.highcharts-container {
  width:100% !important;
}
</style>



// WEBPACK FOOTER //
// Search.vue?0fc15c8b